import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import OnboardingWizard from './VakkenOnboarding';

// Toont de eerste-login-onboarding voor nieuwe docenten (onboarding_gezien
// is NULL, zie migration 034). De sessionStorage-vlag is het vangnet tegen
// her-triggeren: een schoolloze docent kan zijn eigen rij na de update niet
// teruglezen (docenten_select filtert op school_id), dus zonder vlag zou de
// wizard elke navigatie opnieuw kunnen verschijnen.
const dismissKey = (id) => `tw-onboarding-dismissed-${id}`;

function DocentOnboardingGate() {
  const { docentProfile } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (!docentProfile || dismissed) return null;
  if (docentProfile.onboarding_gezien) return null;
  if (docentProfile.rol === 'admin') return null;
  try {
    if (sessionStorage.getItem(dismissKey(docentProfile.id))) return null;
  } catch { /* sessionStorage kan geblokkeerd zijn */ }

  return (
    <OnboardingWizard
      onClose={() => {
        try { sessionStorage.setItem(dismissKey(docentProfile.id), '1'); } catch {}
        setDismissed(true);
      }}
    />
  );
}

export default DocentOnboardingGate;
